import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {flightSchedule} from 'services/flight.service'
import {formatResponse} from './viewSchedules.utils'

export interface viewSchedules {
    isLoading: boolean
    error: any
    initialValues: object
    response: object
    carrier: string
}

const initialState: viewSchedules = {
    isLoading: false,
    error: null,
    initialValues: {
        flightDateTime: new Date(),
        carrier: '-Select-',
        from: '',
        to: ''
    },
    response: [],
    carrier: ''
}

const throwError = (data) => {
    if (!data.successFlag || typeof data === 'string') {
        throw Error(`${data?.errorList[0]?.text} (${data?.errorList[0]?.code})`)
    }
}

export const fetchSchedules = createAsyncThunk('fetchSchedules', async (payload: any, {rejectWithValue}) => {
    let carrier = ''
    try {
        const matches = payload.carrier.match(/\((.*?)\)/)
        if (matches && matches.length >= 2) {
            carrier = matches[1]
        }
        const fltDateTime = payload.flightDateTime
        const request = {
            carrier,
            deptTime: `${fltDateTime.toTimeString().slice(0, 2)}${fltDateTime.toTimeString().slice(3, 5)}`,
            destinationCode: payload.to.code,
            flightDate: payload.flightDateTime,
            originCode: payload.from.code,
            userId: payload.userId
        }
        const {data} = await flightSchedule(request)
        throwError(data)
        return {
            response: formatResponse(data?.response?.ENTRY),
            payload,
            carrier
        }
    } catch (err: any) {
        return rejectWithValue({
            error: err.message,
            payload,
            carrier
        })
    }
})

const viewSchedulesSlice = createSlice({
    name: 'viewSchedules',
    initialState,
    reducers: {
        resetState: (state) => initialState
    },
    extraReducers: function (builder) {
        builder.addCase(fetchSchedules.pending, (state, action) => {
            state.isLoading = true
        })
        builder.addCase(fetchSchedules.fulfilled, (state, action) => {
            state.isLoading = false
            state.response = action.payload.response
            state.carrier = action.payload.carrier
            state.initialValues = action.payload.payload
            state.error = null
        })
        builder.addCase(fetchSchedules.rejected, (state, action: any) => {
            state.isLoading = false
            state.response = []
            state.carrier = action.payload.carrier
            state.initialValues = action.payload.payload
            state.error = action.payload.error
        })
    }
})

export const {resetState} = viewSchedulesSlice.actions
export const {reducer: viewSchedulesReducer} = viewSchedulesSlice
